import { colors, fontSizes } from '../../../../Components/consts'
import { styled } from '@mui/system'

type StyleProps = {
  uiTheme?: 'light' | 'dark'
}

export const MatchupRosterCon = styled('div')<StyleProps>(({ uiTheme }) => ({
  display: 'flex',
  flexDirection: 'column',
  '& h2': {
    color: uiTheme === 'dark' ? colors.white : colors.text,
  },
  '& p': {
    fontSize: fontSizes.small,
    color: uiTheme === 'dark' ? colors.white : colors.text,
  },
}))

export const RosterTableCon = styled('table')<StyleProps>(({ uiTheme, theme }) => ({
  width: '100%',
    borderCollapse: 'collapse',

    '& th': {
      fontSize: 10,
      color: uiTheme === 'dark' ? colors.white : colors.text,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      height: theme.spacing(3),
      '&:first-of-type': {
        textAlign: 'left',
      },
    },
    '& tbody tr': {
      borderTop: `1px solid ${colors.lightGrey}`,
      '&:first-of-type': {
        borderTop: 0,
      },
    },

    '& tbody td': {
      fontSize: 14,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      color: uiTheme === 'dark' ? colors.white : colors.text,
      width: '13%',
      minWidth: 28,
      textAlign: 'center',
      fontWeight: 600,
      '&:first-of-type': {
        width: 'auto',
        textAlign: 'left',
      },
      '& a': {
        color: uiTheme === 'dark' ? colors.white : colors.text,
        textDecoration: 'none',
      },
      '& svg': {
        width: 18,
        marginLeft: theme.spacing(1),
      },
    },
    '& tfoot td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      textAlign: 'center',
      fontWeight: 'normal',
      color: uiTheme === 'dark' ? colors.white : colors.text,
      fontSize: 10,
    },
}))
